import React, { ReactElement, useContext, useEffect, useState } from 'react'
import VotedArtWork from './VotedArtWork'
import { Context } from '@/components/Context'
import CheckBox from '@/components/boxes/CheckBox'
import { VoteData } from '@/database/vote'
import Box from '@/components/boxes/Box'
import { UpdateType } from '@/types/websocket'

const VotesOverview = (): ReactElement => {
    const { filters, toggleFilter, votedDataList, proposalData, setActiveUpdates } = useContext(Context)
    const [totalVotes, setTotalVotes] = useState(0)
    const [activeVotes, setActiveVotes] = useState(0)
    const { activeVote } = filters

    const filteredArt = (votedList: VoteData[]) =>
        votedList.filter((voteData) => {
            if (!activeVote) {
                return true
            }
            return !!(activeVote && proposalData.some((artData) => artData.art.id === voteData.art.id))
        })

    useEffect(() => {
        setActiveUpdates([UpdateType.VOTES, UpdateType.PROPOSALS])
    }, [])

    useEffect(() => {
        setTotalVotes(votedDataList.reduce((acc, voteData) => acc + Number(voteData.vote.amount), 0))
        setActiveVotes(
            votedDataList
                .filter((voteData) => proposalData.some((artData) => artData.art.id === voteData.art.id))
                .reduce((acc, voteData) => acc + Number(voteData.vote.amount), 0),
        )
    }, [votedDataList])

    return (
        <div>
            <h1 className="title">Your Vote</h1>
            <div className="header-container bottom">
                <Box
                    caption={'Active Votes'}
                    text={activeVotes.toFixed(2)}
                    styleCaption={'gray large bold'}
                    styleText={'center'}
                />
                <Box
                    caption={'Total Voted'}
                    text={totalVotes.toFixed(2)}
                    styleCaption={'gray large bold'}
                    styleText={'center'}
                />
            </div>
            <p className={'padding-bottom'}>
                <CheckBox
                    btnName="Active Votes"
                    classStyles=""
                    checked={activeVote}
                    handleClick={() => toggleFilter('activeVote')}
                />
            </p>
            <div className="container width400 center">
                <div className="prompts">
                    <ul>
                        {filteredArt(votedDataList).map((voteData) => (
                            <VotedArtWork key={voteData.vote.id} voteData={voteData} />
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default VotesOverview
